import { Injectable, inject } from "@angular/core";
import { Store } from "@ngrx/store";
import { filter, map, Observable, switchMap } from "rxjs";

import { fetchFeatureFlags } from "../actions/feature-flag-actions";
import {
    FeatureFlagDefinition,
    FeatureFlagName,
    FEATURE_FLAGS,
} from "../constants/feature-flags.constant";
import { FeatureFlagState, NO_FLAGS } from "../reducers/feature-flag.state";
import {
    selectFlags,
    selectIsLoaded,
} from "../selectors/feature-flag.selector";

@Injectable()
export class FeatureFlagFacade {
    private store = inject<Store<FeatureFlagState>>(Store);

    /**
     * Describes the loading status of FF flags
     */
    public isLoaded$: Observable<boolean> = this.store.select(selectIsLoaded);

    public fetchFeatureFlags(flags: FeatureFlagDefinition[]): void {
        this.store.dispatch(fetchFeatureFlags({ flags }));
    }

    /* TO DO: as feature flags are only fetched through the app-initializer token factory, 
    feature flags can be fetched synchronously, flags can be managed outside an ngrxStore and
    isActivated() can return a boolean instead of an Observable<boolean> */
    public isActivated(flagName: FeatureFlagName): Observable<boolean> {
        return this.isLoaded$.pipe(
            filter((isLoaded) => isLoaded), // Ensure flags are loaded
            switchMap(() =>
                this.store.select(selectFlags).pipe(
                    map((flags) => {
                        if (flags === NO_FLAGS) {
                            /**
                             * Thanks to the strong typing we are sure that the ID of the key is present in the array.
                             *
                             * So we force the type (`as boolean`)
                             */
                            return FEATURE_FLAGS.find(
                                (flag) => flag.flagName === flagName,
                            )?.defaultValue as boolean;
                        }
                        return flags[flagName];
                    }),
                ),
            ),
        );
    }
}
